var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114.6 80",
    style: {
      enableBackground: "new 0 0 114.6 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1_1_",
    transform: "translate(-175.12634,-267.07553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2416",
    className: "testimonial",
    d: "M249.1,286.1l-21.3,33.6h-23.3l5.4-8.3h14.5l5.3-8.4h-32.3l-5.3,8.4h7.7L189.3,328h43.4 l16.4-26.2l6,9.6h-5.2l-5.3,8.3h15.7l5.3,8.4h10L249.1,286.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2418",
    className: "testimonial",
    d: "M242.1,286.4h-34.3l-5.3,8.4l34.3-0.1L242.1,286.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEa);
export default __webpack_public_path__ + "static/media/ea.6608825e6fbba4a2772aaf6cdb48e1a8.svg";
export { ForwardRef as ReactComponent };